function Accolades(){

  return (
    <div>
        <h1>Accolades for April's Horror Corner</h1>
        <p>"This is the Sistine Chapel of personal websites!" &nbsp;~my dad</p>
        <p>"You really put all the bells and whistles on it, didn't you, April?" &nbsp;~Chloe</p>
        <p>"Hahahaha I love it!" &nbsp;~Miranda</p>
        <p>*middle finger emoji* &nbsp;~Jenna</p>
        <p>"This place is the posterior of the global network, otherwise known as, in layman's terms, 'the internet.'" &nbsp;~Collin</p>
        <p>"Why did you put so much effort into making this?" &nbsp;~random guy on Tinder</p>
    </div>
  );
}

export default Accolades;